/* eslint-disable no-underscore-dangle */
import React from 'react'
import { Button, Typography } from '@mui/material'
import { parseName } from '../utils'

function downloadPdfFile(base64) {
  const linkSource = `data:application/pdf;base64,${base64}`
  const downloadLink = document.createElement('a')
  const fileName = 'documento.pdf'
  downloadLink.href = linkSource
  downloadLink.download = fileName
  downloadLink.click()
}

export function DownloadIcon() {
  return (
    <svg
      width="15"
      height="20"
      viewBox="0 0 15 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.75 5.3125V0H0.9375C0.417969 0 0 0.417969 0 0.9375V19.0625C0 19.582 0.417969 20 0.9375 20H14.0625C14.582 20 15 19.582 15 19.0625V6.25H9.6875C9.17188 6.25 8.75 5.82812 8.75 5.3125ZM11.7363 13.5687L7.96992 17.307C7.71016 17.5652 7.29063 17.5652 7.03086 17.307L3.26445 13.5687C2.86797 13.1754 3.14609 12.5 3.70391 12.5H6.25V9.375C6.25 9.02969 6.52969 8.75 6.875 8.75H8.125C8.47031 8.75 8.75 9.02969 8.75 9.375V12.5H11.2961C11.8539 12.5 12.132 13.1754 11.7363 13.5687ZM14.7266 4.10156L10.9023 0.273438C10.7266 0.0976562 10.4883 0 10.2383 0H10V5H15V4.76172C15 4.51562 14.9023 4.27734 14.7266 4.10156Z"
        fill="#111D7D"
      />
    </svg>
  )
}

export function DownloadButton({ file, base64, number }) {
  const pdfbase64 = file?._text || base64
  const type = file?._attributes?.tipo
  const notes = file?._attributes?.observacoes

  return (
    <div className="download-button">
      <Button
        size="large"
        startIcon={<DownloadIcon />}
        onClick={() => {
          downloadPdfFile(pdfbase64)
        }}
      >
        Baixar arquivo {type ? parseName(type) : number} (PDF)
      </Button>
      {notes && (
        <Typography style={{ paddingLeft: 36, marginBottom: 13 }}>
          {notes}
        </Typography>
      )}
    </div>
  )
}

export function DownloadPdfs({ content }) {
  const isArray = Array.isArray(content)

  if (isArray) {
    return content.map((file, index) => {
      const key = file + index
      return <DownloadButton key={key} number={index + 1} file={file} />
    })
  }

  return <DownloadButton file={content} />
}

export default function DownloadPdf({ content }) {
  return (
    <div style={{ padding: '0px 20px' }}>
      <DownloadPdfs content={content} />
    </div>
  )
}
